import React from 'react';
import { SelectionProcessesPage } from '@rankmi/ats-app';
import { RequestModalComponent } from '@fcomponents/molecules/RequisitionFormViewer';

const SelectionProcessIndex = ({
  current_user,
  isBasicWithUserColumns,
  userRole,
  canCreate,
  isAdmin,
  // titleAllProcess,
  enterprise,
}) => {
  return <SelectionProcessesPage
    currentUser={current_user}
    isBasicWithUserColumns={isBasicWithUserColumns}
    userRole={userRole}
    canCreate={canCreate}
    isAdmin={isAdmin}
    enterprise={enterprise}
    registeredComponents={{
      requestModal: RequestModalComponent
    }}
  />;
};

export default SelectionProcessIndex;